import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { TextInputControl } from "@cloudpivot/form/src/common/controls/input-controls/text-input-control";
import { H3Input, H3Textarea } from "h3-mobile-vue";
import MutilText from "@cloudpivot/form/src/common/components/mutil-text.vue";
let InputText = class InputText extends TextInputControl {
    onBlur() {
        super.validate();
    }
    onChange() {
        this.ctrl.value = this.val.length === 0 ? null : this.val;
    }
    onChangeTextarea() {
        let el = this.$refs.h3Textarea.$el;
        let h = el.offsetHeight;
        el.style.height = `${el.offsetHeight}px`;
        this.ctrl.value = this.val.length === 0 ? null : this.val;
        setTimeout(() => {
            el.style.height = "auto";
        }, 16.66666666);
    }
};
InputText = tslib_1.__decorate([
    Component({
        name: "input-text",
        components: {
            H3Input,
            H3Textarea,
            MutilText
        }
    })
], InputText);
export default InputText;
